import React from "react";
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";

const leftSidedImageCopyItemCollectionData = [
  {
    description: [
      "With consideration to the structural integrity of the home a dated and largely redundant pool positioned against the house was demolished making way for generous entertaining areas that were sympathetic to both the home and the natural setting.",
      "A sophisticated combination of natural stone, cedar and sand coloured paint allow the built element to sit comfortably amongst the tall eucalypts. Outdoor lighting allows the garden to be enjoyed long after the sun has set.",
      "Low stone walls and furnishings provide subtle separations to the space which create defined area to entertain, relax and dine.",
    ],
    descriptionContent: (
      <>
        <p>
          <span className="line">
            <b>Services Undertaken</b>
            <br />
            Construction
          </span>
          <b>Design Features</b>
          <br />
          Contemporary
          <br />
          Family
          <br />
          Entertainer
          <br />
          Classic
          <br />
          Seaside
        </p>
      </>
    ),
    image: "../images/projects/brooks-2.jpg",
    title: "Palm Beach",
  },
];

const projectImageDetailPageCollectionData = [
  {
    dataId: "a1",
    image: "../images/projects/brooks-1.jpg",
  },
  {
    dataId: "a4",
    image: "../images/projects/brooks-4.jpg",
  },
  {
    dataId: "a8",
    image: "../images/projects/brooks-8.jpg",
  },
  {
    dataId: "a2",
    image: "../images/projects/brooks-2.jpg",
  },
  {
    dataId: "a3",
    image: "../images/projects/brooks-3.jpg",
  },
  {
    dataId: "a5",
    image: "../images/projects/brooks-5.jpg",
  },
];

const PagePalmBeach = () => {
  return (
    <LayoutMain>
      <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
    </LayoutMain>
  );
};

export default PagePalmBeach;
